var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferrals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 20H15V21H2V20H1V17H2V16H3V15H4V14H13V15H14V16H15V17H16V20Z",
    fill: "#929292"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12V11H14V5H18V6H19V11H18V12H13Z",
    fill: "#929292"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 17V20H22V21H16V20H17V16H16V15H15V14H20V15H21V16H22V17H23Z",
    fill: "#929292"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3V4H11V5H10V4H9V3H8V4H7V5H6V4H5V3H4V10H5V11H6V12H11V11H12V10H13V3H12ZM11 9H10V10H7V9H6V7H11V9Z",
    fill: "#929292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferrals);
export default __webpack_public_path__ + "static/media/referrals.99207ab067b202dc66f787b435ee023e.svg";
export { ForwardRef as ReactComponent };